





















import { Component, Prop, Vue } from 'vue-property-decorator';
import ArrowIcon from 'frontend/components/icons/ArrowIcon.vue';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';

@Component({
  components: {
    ArrowIcon,
  },
})
export default class LearningPathPill extends Vue {
  @Prop({ type: Object, required: true }) private learningPath!: RelatedLearningPathInfo;
}
